import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'portal.components.userLocationSettings.title',
    defaultMessage: 'Location settings',
    description: 'Location settings modal title',
  },
  description: {
    id: 'portal.components.userLocationSettings.description',
    defaultMessage: 'Fill in the form below to set your country & city location.',
    description: 'Location settings modal description',
  },
  countryLabel: {
    id: 'portal.components.userLocationSettings.field.country.label',
    defaultMessage: 'Country *',
    description: 'Country label. The trailing "*" is the required-field marker — keep it (or the '
      + "locale's own equivalent) when translating, in whatever position and punctuation reads "
      + 'naturally for that language; the marker lives in this string, not in code, precisely so a '
      + 'translator can place or drop it per their own convention. The field cannot be left blank.',
  },
  saveButton: {
    id: 'portal.components.userLocationSettings.save.button.text',
    defaultMessage: 'Save',
    description: 'Save button text',
  },
  locationSuccess: {
    id: 'portal.components.userLocationSettings.location.success.message',
    defaultMessage: 'Location data submitted successfully.',
    description: 'Location success notification message',
  },
  locationError: {
    id: 'portal.components.userLocationSettings.location.error.message',
    defaultMessage: 'An error occurred while saving location data.',
    description: 'Location error notification message',
  },
});

export default messages;
